import { createFileRoute } from "@tanstack/react-router";

import TodosSort from "@/features/todos/todos-sort";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/ausgang/sort",
)({
  component: ReceivableSortPage,
  staticData: {
    breadcrumb: ["todos.receivable.title"],
  },
});

function ReceivableSortPage() {
  return <TodosSort type="receivable" />;
}
